export default "__VITE_ASSET__c91daea9__"